module.exports = __webpack_public_path__ + "img/foundation-logo.b88a5d99.png";